module.exports = __webpack_public_path__ + "img/preset-walk.559aa354.svg";